// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mr3c","content":"styles_content__2Wt8B"};